/** Commodity / crop names used in dropdowns and multi-selects across the admin app. */
export const CROP_PRODUCT_OPTIONS = [
  'Maize',
  'Soya Beans',
  'Onion',
  'Pepper',
  'Tomatoes',
  'Fresh Pepper',
  'Dry Pepper',
  'Pepper Powder',
  'Sheabutter',
];

/** Farmer registration includes rice as an optional crop. */
export const CROP_PRODUCT_OPTIONS_WITH_RICE = [...CROP_PRODUCT_OPTIONS, 'Rice'];
